import script from "./VContentEditable.vue?vue&type=script&setup=true&lang=ts"
export * from "./VContentEditable.vue?vue&type=script&setup=true&lang=ts"

import "./VContentEditable.vue?vue&type=style&index=0&id=d6ae5592&lang=scss"

const __exports__ = script;

export default __exports__